import Vue from 'global-vue'
import di from 'di'

import moment from 'moment'

import merge from 'lodash/merge'
import each from 'lodash/each'

import messages from 'app/i18n'

export default class {

    run(){

        const i18n = di.get('i18n');

        // Merge messages with app messages
        each(messages, (langMessages, lang) => i18n.setLocaleMessage(lang, merge(i18n.getLocaleMessage(lang), langMessages)));

        i18n.locale = 'nl';
        moment.locale(i18n.locale);
    }
}